import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _ctx.compId,
      class: _normalizeClass({ 'visuallyhidden': _ctx.labelHidden })
    }, _toDisplayString(_ctx.$t('common.search')), 11, _hoisted_2),
    _createElementVNode("button", {
      id: _ctx.compId,
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked'))),
      class: "btn btn-brand1 w-100"
    }, _toDisplayString(_ctx.$t('common.search')), 9, _hoisted_3)
  ]))
}